<template>
  <div class="mobile_container">
    <ul>
      <p class="title-time">2018-06-28</p>
      <li>
        <p class="status">关闭成功</p>
        <p class="operate">
          <span>管理员</span>
          <span>15:59:00</span>
        </p>
      </li>
      <li>
        <p class="status">关闭成功</p>
        <p class="operate">
          <span>管理员</span>
          <span>15:59:00</span>
        </p>
      </li>
      <li>
        <p class="status">关闭成功</p>
        <p class="operate">
          <span>管理员</span>
          <span>15:59:00</span>
        </p>
      </li>
      <li>
        <p class="status">关闭成功</p>
        <p class="operate">
          <span>管理员</span>
          <span>15:59:00</span>
        </p>
      </li>
      <li>
        <p class="status">关闭成功</p>
        <p class="operate">
          <span>管理员</span>
          <span>15:59:00</span>
        </p>
      </li>
      <li>
        <p class="status">关闭成功</p>
        <p class="operate">
          <span>管理员</span>
          <span>15:59:00</span>
        </p>
      </li>
      <li>
        <p class="status">关闭成功</p>
        <p class="operate">
          <span>管理员</span>
          <span>15:59:00</span>
        </p>
      </li>
      <li>
        <p class="status">关闭成功</p>
        <p class="operate">
          <span>管理员</span>
          <span>15:59:00</span>
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
  import config from '@/config.js'

  export default {
    name: 'index',
    components: {},
    data() {
      return {
        baseUrl: config("baseServerUrl", "."),
        deviceId: 0,
      }
    },
    mounted: function () {
      setTitle("历史记录")
    },
    created: function () {
      // this.deviceId = this.$route.params.Id
      this.deviceId = this.$route.query.Id
    },
    methods: {
      console() {

      },
    }
  }
</script>

<style lang="less" scoped>
  .mobile_container {
    ul {
      p.title-time {
        padding: 0.12rem 0.16rem;
        background: #F5F6FA;
        font-family: '微软雅黑';
        font-weight: 400;
        font-style: normal;
        font-size: 0.2rem;
      }
      li {
        padding: 0.32rem 0.28rem;
        overflow: hidden;
        border-bottom: solid 0.02rem rgba(233, 233, 233, 1);
        p.status {
          float: left;
          font-family: '微软雅黑';
          font-weight: 400;
          font-style: normal;
          font-size: 0.32rem;
          color: rgba(0, 0, 0, 0.847058823529412);
        }
        p.operate {
          float: right;
          margin-top: -0.12rem;
          span:nth-child(1) {
            display: block;
            font-family: '微软雅黑';
            font-weight: 400;
            font-style: normal;
            font-size: 0.28rem;
            color: rgba(0, 0, 0, 0.847058823529412);
          }
          span:nth-child(2) {
            display: block;
            font-family: '微软雅黑';
            font-weight: 400;
            font-style: normal;
            font-size: 0.2rem;
            color: #999999;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mobile/controllerHistory.vue